<template>
  <div class="mt-5 paging-wrapper">
    <b-pagination
      id="pagination"
      v-model="pageCount"
      :total-rows="totalRows"
      :per-page="selectedRowCount"
      limit="5"
      align="center"
    >
    </b-pagination>
    <b-form-select
      v-model="selectedRowCount"
      :options="options"
      class="paging-dropdown"
    ></b-form-select>
    <div class="small mt-2 text-muted ml-2 rowPerPageTxt">sor/oldal</div>
  </div>
</template>

<script>
export default {
  name: "Paging",
  watch: {
    selectedRowCount(val) {
      this.saveStateToStorage();
      this.$emit("paging-change", {
        pagingPage: this.pageCount,
        pagingOffset: val,
      });
    },
    pageCount(val) {
      this.saveStateToStorage();
      this.$emit("paging-change", {
        pagingPage: val,
        pagingOffset: this.selectedRowCount,
      });
    },
    itemPerPage(newVal) {
      // Update selectedRowCount when prop changes
      if (newVal && newVal !== this.selectedRowCount) {
        this.selectedRowCount = newVal;
      }
    },
    page(newVal) {
      // Update pageCount when prop changes
      if (newVal && newVal !== this.pageCount) {
        this.pageCount = newVal;
      }
    },
  },
  props: {
    stateId: {
      type: String,
      default: null,
    },
    page: {
      type: Number,
      default: 1,
    },
    totalRows: {
      type: Number,
      default: 1000,
    },
    itemPerPage: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      selectedRowCount: this.getSelectedRowCountFromState(this.itemPerPage),
      options: [
        { value: 5, text: "5" },
        { value: 10, text: "10" },
        { value: 25, text: "25" },
        { value: 50, text: "50" },
      ],
      rows: this.totalRows,
      pageCount: this.getSelectedPageFromState(this.page),
    };
  },
  methods: {
    saveStateToStorage() {
      if (this.stateId) {
        const state = {
          pagingPage: this.pageCount,
          pagingOffset: this.selectedRowCount,
          totalRows: this.totalRows,
        };
        localStorage.setItem(`${this.stateId}-state`, JSON.stringify(state));
      }
    },
    getSelectedRowCountFromState(fallback) {
      return this.getStateFromStorage(fallback).pagingOffset;
    },
    getSelectedPageFromState(fallback) {
      return this.getStateFromStorage(fallback).pagingPage;
    },
    getStateFromStorage(fallback) {
      if (this.stateId) {
        let state = localStorage.getItem(`${this.stateId}-state`);
        if (state) {
          return JSON.parse(state);
        }
      }

      return {
        pagingOffset: fallback,
        pagingPage: fallback,
      };
    },
  },
  created() {
    let self = this;
    self.rows = self.totalRows;
  },
};
</script>

<style scoped>
.paging-dropdown >>> button.page-link {
  margin: 0 1px;
}

.paging-dropdown >>> li.page-item.disabled.bv-d-xs-down-none {
  padding-top: 1px;
}

.paging-dropdown >>> .page-link {
  padding-top: 1px !important;
}

.paging-wrapper {
  display: flex;
  justify-content: center;
  padding-top: 10px;
}

.paging-wrapper * {
  font-family: JumperThin !important;
}

@media screen and (max-width: 768px) {
  .paging-wrapper {
    overflow-x: scroll;
  }
}

.paging-dropdown {
  width: 60px;
}

#pagination >>> .page-item.active .page-link {
  border: 1px solid #252734 !important;
  border-radius: 32px !important;
  padding: 8px 15px 8px 15px;
  margin-top: -1px;

}

#pagination >>> .page-link {
  color: #252734 !important;
  background-color: transparent !important;
  border: none;
  margin-left: 5px;
  margin-right: 5px;
}

#app input,
#app select {
  background-color: transparent !important;
  color: #252734 !important;
  height: max-content !important;
  border: 1px solid #252734 !important;
  border-radius: 32px !important;
  padding: 8px !important;
  padding-left: 10px !important;
  margin-left: 10px !important;
  box-shadow: none !important;
}

@media screen and (max-width: 768px) {
  #pagination >>> .page-link {
    padding: 8px 2px 8px 2px;
  }
  .rowPerPageTxt {
    font-size: 8px;
    padding-top: 5px;
  }
}
</style>
